<template>
  <router-link class="my-button" :class="[type, size]" :to="this.link">
    <slot/>
  </router-link>
</template>

<script>
export default {
  props: {
    type: {
      type: String,
      default: '',
    },
    size: {
      type: String,
      default: '',
    },
    link: {
      type: Object,
    },
  },
};
</script>

<style scoped>

.my-button {
  display: block;
  text-decoration: none;
  color: #000;
  min-width: 120px;
  font-size:15px;
  line-height: 15px;
  text-align: center;
  padding: 10px;
  border: 3px solid #AAAFB6;
  border-radius: 20px;
  cursor: pointer;
  transition: .2s;
  user-select:none;
}

.my-button.back {
  background:#eee;
  border:3px solid #eee;
}

.my-button.back:hover {
  background: #D8D8D8;
}

.my-button.red {
  background: #D84C60;
  border: 3px solid #D84C60;
  color: #ffffff;
}

.my-button.red:hover {
  background: #fff;
  color: #D84C60;
}

.my-button.blue {
  background: #2E75B5;
  border: 3px solid #2E75B5;
  color: #ffffff;
}

.my-button.blue:hover {
  background: #fff;
  color: #2E75B5;
}

.my-button.small {
  padding: 5px 10px;
}
.my-button.large {
  padding: 15px 30px;
}

.my-button.long {
  padding: 10px 45px;
}

.my-button.very-long {
  padding: 10px 70px;
}
</style>
